import React from "react";
import Page404 from "../../../Pages/404";
import CustomerPage from "./customerPage";
import CustomerGroupPage from "./customerGroupPage";

const TAB = {
    CUSTOMER: "customer",
    CUSTOMERGROUP: "customerGroup",
}

const TabContent = ({currentPage}) => {
    switch(currentPage){
        case TAB.CUSTOMER:
            return <CustomerPage/>;
        case TAB.CUSTOMERGROUP:
            return <CustomerGroupPage/>;
        default:
            return <Page404/>;
    }
};
export default TabContent
